import { TranslateModule } from '@ngx-translate/core';
import { Component, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AccountRequestComponent } from 'error/forbidden/request-access/account-request.component';
import { MatDialog } from '@angular/material/dialog';
import { ButtonDirective } from 'common/button/button.directive';
import { IconDirective } from 'common/icon/icon.directive';

@Component({
  templateUrl: 'forbidden.component.html',
  styleUrls: ['forbidden.component.scss'],
  imports: [TranslateModule, ButtonDirective, IconDirective],
})
export class ForbiddenComponent {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  userData = this.oidcSecurityService.userData;
  readonly dialog = inject(MatDialog);

  async accountRequest() {
    this.dialog.open(AccountRequestComponent, {});
  }
}
